//original js
//ECサイト内での検索で検索非表示（'password-required', 'goaffpro', 'catalog'をハンドルに含むページ）

document.addEventListener('DOMContentLoaded', function() {
    var excludedStrings = ['password-required', 'goaffpro', 'catalog' , 'thank-you-for-registering']; // 除外したい文字列の配列
    var searchResults = document.querySelectorAll('.grid-search-page.search-page-grid .grid__item-search-page'); // 検索結果のリスト（li）を取得
    var productPages = document.querySelectorAll('.template-search__results .product-grid .grid__item'); // 商品ページのリスト（li）を取得

    // URL が除外すべき文字列を含んでいるかどうかを確認する関数
    function shouldExclude(url) {
        return excludedStrings.some(function(excludedString) {
            return url.includes(excludedString);
        });
    }

    // 各検索結果をループして除外する
    searchResults.forEach(function(result) {
        var resultUrlElement = result.querySelector('a.full-unstyled-link');
        if (resultUrlElement) {
            var resultUrl = resultUrlElement.getAttribute('href');
            if (shouldExclude(resultUrl)) {
                result.style.display = 'none'; // ページを非表示にする
            }
        }
    });

    // 各商品ページをループして除外する
    productPages.forEach(function(product) {
        var productUrlElement = product.querySelector('a.full-unstyled-link');
        if (productUrlElement) {
            var productUrl = productUrlElement.getAttribute('href');
            if (shouldExclude(productUrl)) {
                product.style.display = 'none'; // ページを非表示にする
            }
        }
    });
});

